export default class HorTextScroller {
    constructor() {
        const scrollers = document.querySelectorAll('.ce-marquee')
        for (const scroller of scrollers) {
            if (scroller.hasAttribute('data-scroller-init')) continue
            scroller.setAttribute('data-scroller-init', '')
            new Scroller(scroller)
        }
    }
}

class Scroller {
    private content: HTMLElement
    private contentWidth: number
    private contentWrapper: HTMLElement
    private contentText: string
    private contentTextClone: string
    private animationId: number

    constructor(scroller: Element) {
        this.content = scroller.querySelector(
            '.ce-marquee__content > [data-scroller-text]'
        )
        if (!this.content) return
        this.contentWidth = this.content.offsetWidth
        if (!this.contentWidth) return
        this.contentText = this.content.getAttribute('data-scroller-text')
        if (!this.contentText) return
        this.contentTextClone = ` • ${this.contentText}`
        this.contentWrapper = scroller.querySelector('.ce-marquee__content')
        this.init()
    }

    // init
    private init() {
        this.cloneContent()
        this.addEventListeners()

        const speed = 0.2
        let i = 0

        const animate = () => {
            this.content.style.transform = `translateX(-${i}px)`
            if (i > this.contentWrapper.clientWidth) {
                i = 0
            }
            i = i + speed
            this.animationId = requestAnimationFrame(animate)
        }
        this.animationId = requestAnimationFrame(animate)
    }

    // clone content
    private cloneContent() {
        this.content.innerText = this.contentText
        const multiplier = Math.ceil(window.innerWidth / this.contentWidth) * 2
        for (let index = 0; index < multiplier; index++) {
            this.content.insertAdjacentText('beforeend', this.contentTextClone)
        }
    }

    // event listeners
    private addEventListeners() {
        window.addEventListener('resize', () => {
            this.cloneContent()
        })
    }
}
